/** SIMS-9441 — released component a version belongs to. */
export enum AppVersionPlatform {
	IOS = "IOS",
	ANDROID = "ANDROID",
	BACKOFFICE = "BACKOFFICE",
}

/** Display order and labels, shared by the maintenance page and the Versions modal. */
export const APP_VERSION_PLATFORMS: {
	value: AppVersionPlatform;
	label: string;
}[] = [
	{ value: AppVersionPlatform.IOS, label: "iOS" },
	{ value: AppVersionPlatform.ANDROID, label: "Android" },
	{ value: AppVersionPlatform.BACKOFFICE, label: "Backoffice" },
];

/** Mobile platforms: the app blocks itself below their current version. */
export const MOBILE_PLATFORMS: AppVersionPlatform[] = [
	AppVersionPlatform.IOS,
	AppVersionPlatform.ANDROID,
];

export const platformLabel = (platform: string): string =>
	APP_VERSION_PLATFORMS.find((p) => p.value === platform)?.label ?? platform;

export interface AppVersion {
	_id: string;
	platform: AppVersionPlatform;
	version: string;
	apiVersion?: string;
	functionalVersion?: string;
	isCurrent: boolean;
	releaseNotes?: string;
	storeUrl?: string;
	createdAt?: string;
	updatedAt?: string;
}

export interface SaveAppVersion {
	platform: AppVersionPlatform;
	version: string;
	apiVersion?: string;
	functionalVersion?: string;
	releaseNotes?: string;
	storeUrl?: string;
}
